import { User } from "@/model/user";
import { UserDataModel } from "@/shared/model/user-data.model";
import { Client } from "./client";

export class UserApi {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async getMe(): Promise<User | null> {
    const response = await this.client.fetch(`/user`);

    const json = await response.json();

    return json.data as User;
  }

  async getUserData(): Promise<UserDataModel | null> {
    const response = await this.client.fetch(`/user/data`);

    const json = await response.json();

    return json.data as UserDataModel;
  }

  async sendEmailVerification(email: string): Promise<void> {
    await this.client.fetch(`/auth/send-email-verification`, {
      method: "POST",
      body: JSON.stringify({ email }),
    });
  }

  async logout(): Promise<void> {
    await this.client.fetch(`/auth/logout`, {
      method: "POST",
    });
  }

  async deleteAccount(): Promise<void> {
    await this.client.fetch(`/user`, {
      method: "DELETE",
    });
  }
}
